<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            <!--            <el-input size="mini" type="text" v-model="store.state.customer.shortName"  @input="updateInput"></el-input>-->
            {{ titleName }}
            <span v-if="littleName || titleName != ''">-</span>
            {{ littleName }}
          </div>
          <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;">
              <yi_data_select :type="'organization'" :ids.sync="orgId"> </yi_data_select>
              <el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;" icon="yicon yicon-pencil">
                {{ $t("bianjikanban") }}
              </el-link>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
    <div v-show="isShowEquipment" style="position: absolute;background: gray;height: 100%;width: 100%;z-index: 1;">
      <equipment v-if="isShowEquipment" :equipment="currentEquipment"></equipment>
    </div>
    <el-dialog :show-close="true" :title="$t('kanbanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
      <div class="dialog-scroller">
        <setting ref="setting"></setting>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowBoardEdit = false">{{ $t("quxiao") }}</el-button>
        <el-button size="mini" @click="
          $refs.setting.save();
        isShowBoardEdit = false;
        " type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
import alert from "@@/pages/web/monitor/workshop/alert";
import card from "@@/pages/web/monitor/workshop/card";
import hour_output from "@@/pages/web/monitor/workshop/hour_output";
import oee from "@@/pages/web/monitor/workshop/oee";
import equipment from "@@/pages/web/monitor/workshop/equipment/index";
import setting from "@@/pages/web/monitor/workshop/setting";
export default {
  name: "web_customize_gelanda_monitor_cast_slag_index",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    alert: alert,
    card: card,
    hour_output: hour_output,
    oee: oee,
    equipment: equipment,
    setting: setting,
  },

  data() {
    return {
      titleName: '',
      littleName: '',
      isShowBoardEdit: false,
      orgId: null,
      currentEquipment: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      isShowEquipment: false,
      layout: [],
      monitorSetting: {},
    };
  },
  created() {
    this.orgId = (localStorage.getItem("MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code) != null && !isNaN(parseInt(localStorage.getItem("MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code)))) ? parseInt(localStorage.getItem("MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code)) : this.store.state.organizations[0].id


    this.setLayout();
    this.utils.event_hub.$emit("TOGGLE_TABBAR", true);
    // this.utils.event_hub.$emit("SetCard", true);
    // this.utils.event_hub.$on("SetCard", (card) => {
    //
    // });
    this.utils.event_hub.$on("SHOW_WORKSHOP_EQUIPMENT", (eq) => {
      this.currentEquipment = eq;
      this.isShowEquipment = true;
    });
    this.utils.event_hub.$on("HIDE_WORKSHOP_EQUIPMENT", () => {
      this.isShowEquipment = false;
    });

  },

  watch: {
    "orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      //保存


      localStorage.setItem("MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code, newValue)
    },
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("SetLayoutWorkshop", () => {
      this.setLayout();
    });
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });


  },
  destroyed() {
    this.utils.event_hub.$off("SetLayoutWorkshop");
  },
  methods: {
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_TEMPLATE == null) {
        this.monitorSetting.MONITOR_TEMPLATE = "moren";
      }
      if (this.monitorSetting["IS_MONITOR_WORKSHOP_HEADER_" + this.store.state.customer.id] != null) {
        this.titleName = this.monitorSetting["IS_MONITOR_WORKSHOP_HEADER_" + this.store.state.customer.id];
      } else {
        this.titleName = this.store.state.customer.shortName
      }
      if (this.monitorSetting["MONITOR_WORKSHOP_CARD_TITLE_" + this.store.state.customer.id] != null) {
        this.littleName = this.monitorSetting["MONITOR_WORKSHOP_CARD_TITLE_" + this.store.state.customer.id];
      } else {
        this.littleName = this.$t('chejianjiankong')
      }

      if (this.monitorSetting.MONITOR_TEMPLATES == null) {
        this.monitorSetting.MONITOR_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 8,
              h: 6, //应该是6
              i: "oee",
            },
            {
              x: 8,
              y: 0,
              w: 12,
              h: 6, //应该是6
              i: "hour_output",
            },
            {
              x: 20,
              y: 0,
              w: 4,
              h: 24,
              i: "alert",
            },
            {
              x: 0,
              y: 6,
              w: 20,
              h: 18, //应该是18
              i: "card",
            },
          ],
        };
      }

      this.layout = this.monitorSetting.MONITOR_TEMPLATES[this.monitorSetting.MONITOR_TEMPLATE];
    },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
        this.$refs.setting.resetData();
      });
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    },
  },
};
</script>
